// jQuery

(function ($) {
  const default_winkel = {
    balkon: 60,
    flachdach: 20,
    schraegdach: 40,
    fassade: 50,
  };

  const modul_price = {
    1: -309,
    2: -531,
    3: -759,
    4: -906,
  };

  const verbrauch = {
    1: 1800,
    2: 2300,
    3: 2800,
    4: 3300,
    5: 3800,
    6: 4300,
    7: 4800,
    8: 5200,
    9: 5600,
    10: 6000,
  };

  const plz = {
    "01": 1.014,
    "02": 1.032,
    "03": 1.037,
    "04": 1.005,
    "06": 1.023,
    "07": 0.996,
    "08": 1.005,
    "09": 1.01,
    10: 0.996,
    12: 1.001,
    13: 0.996,
    14: 0.996,
    15: 1.023,
    16: 0.978,
    17: 0.974,
    18: 0.987,
    19: 0.965,
    20: 0.934,
    21: 0.934,
    22: 0.943,
    23: 0.943,
    24: 0.929,
    25: 0.935,
    26: 0.947,
    27: 0.929,
    28: 0.934,
    29: 0.961,
    30: 0.961,
    31: 0.947,
    32: 0.938,
    33: 0.929,
    34: 0.943,
    35: 0.961,
    36: 0.978,
    37: 0.943,
    38: 0.965,
    39: 0.987,
    40: 0.969,
    41: 0.978,
    42: 0.969,
    44: 0.961,
    45: 0.961,
    46: 0.965,
    47: 0.978,
    48: 0.956,
    49: 0.943,
    50: 0.978,
    51: 0.952,
    52: 0.974,
    53: 0.961,
    54: 0.996,
    55: 1.001,
    56: 0.992,
    57: 0.934,
    58: 0.938,
    59: 0.934,
    60: 1.023,
    61: 1.01,
    63: 1.019,
    64: 1.032,
    65: 0.996,
    66: 1.041,
    67: 1.037,
    68: 1.05,
    69: 1.041,
    70: 1.068,
    71: 1.068,
    72: 1.059,
    73: 1.05,
    74: 1.059,
    75: 1.064,
    76: 1.064,
    77: 1.059,
    78: 1.077,
    79: 1.055,
    80: 1.104,
    81: 1.104,
    82: 1.095,
    83: 1.077,
    84: 1.091,
    85: 1.091,
    86: 1.082,
    87: 1.095,
    88: 1.109,
    89: 1.068,
    90: 1.05,
    91: 1.055,
    92: 1.046,
    93: 1.05,
    94: 1.077,
    95: 1.005,
    96: 1.014,
    97: 1.037,
    98: 0.978,
    99: 0.983,
  };

  const aufstellfaktor = {
    0: {
      0: 0.87,
      10: 0.93,
      20: 0.97,
      30: 1.0,
      40: 1.0,
      50: 0.98,
      60: 0.94,
      70: 0.88,
      80: 0.8,
      90: 0.6,
    },
    22.5: {
      0: 0.87,
      10: 0.93,
      20: 0.97,
      30: 0.99,
      40: 0.99,
      50: 0.96,
      60: 0.92,
      70: 0.86,
      80: 0.78,
      90: 0.69,
    },
    45: {
      0: 0.87,
      10: 0.92,
      20: 0.94,
      30: 0.85,
      40: 0.94,
      50: 0.92,
      60: 0.87,
      70: 0.81,
      80: 0.74,
      90: 0.64,
    },
    67.5: {
      0: 0.87,
      10: 0.9,
      20: 0.9,
      30: 0.89,
      40: 0.87,
      50: 0.84,
      60: 0.79,
      70: 0.73,
      80: 0.66,
      90: 0.57,
    },
    90: {
      0: 0.87,
      10: 0.87,
      20: 0.85,
      30: 0.82,
      40: 0.79,
      50: 0.75,
      60: 0.7,
      70: 0.7,
      80: 0.56,
      90: 0.48,
    },
    112.5: {
      0: 0.87,
      10: 0.84,
      20: 0.79,
      30: 0.74,
      40: 0.7,
      50: 0.65,
      60: 0.59,
      70: 0.53,
      80: 0.46,
      90: 0.39,
    },
    135: {
      0: 0.87,
      10: 0.81,
      20: 0.74,
      30: 0.68,
      40: 0.61,
      50: 0.54,
      60: 0.48,
      70: 0.42,
      80: 0.35,
      90: 0.29,
    },
    157.5: {
      0: 0.87,
      10: 0.79,
      20: 0.7,
      30: 0.63,
      40: 0.55,
      50: 0.46,
      60: 0.39,
      70: 0.33,
      80: 0.27,
      90: 0.22,
    },
    180: {
      0: 0.87,
      10: 0.79,
      20: 0.7,
      30: 0.61,
      40: 0.52,
      50: 0.43,
      60: 0.35,
      70: 0.28,
      80: 0.23,
      90: 0.18,
    },
    202.5: {
      0: 0.87,
      10: 0.79,
      20: 0.7,
      30: 0.63,
      40: 0.55,
      50: 0.46,
      60: 0.39,
      70: 0.33,
      80: 0.27,
      90: 0.22,
    },
    225: {
      0: 0.87,
      10: 0.81,
      20: 0.74,
      30: 0.68,
      40: 0.61,
      50: 0.54,
      60: 0.48,
      70: 0.42,
      80: 0.35,
      90: 0.29,
    },
    247.5: {
      0: 0.87,
      10: 0.84,
      20: 0.79,
      30: 0.74,
      40: 0.7,
      50: 0.65,
      60: 0.59,
      70: 0.53,
      80: 0.46,
      90: 0.39,
    },
    270: {
      0: 0.87,
      10: 0.87,
      20: 0.85,
      30: 0.82,
      40: 0.79,
      50: 0.75,
      60: 0.7,
      70: 0.7,
      80: 0.56,
      90: 0.48,
    },
    292.5: {
      0: 0.87,
      10: 0.9,
      20: 0.9,
      30: 0.89,
      40: 0.87,
      50: 0.84,
      60: 0.79,
      70: 0.73,
      80: 0.66,
      90: 0.57,
    },
    315: {
      0: 0.87,
      10: 0.92,
      20: 0.94,
      30: 0.85,
      40: 0.94,
      50: 0.92,
      60: 0.87,
      70: 0.81,
      80: 0.74,
      90: 0.64,
    },
    337.5: {
      0: 0.87,
      10: 0.93,
      20: 0.97,
      30: 0.99,
      40: 0.99,
      50: 0.96,
      60: 0.92,
      70: 0.86,
      80: 0.78,
      90: 0.69,
    },
    360: {
      0: 0.87,
      10: 0.93,
      20: 0.97,
      30: 1.0,
      40: 1.0,
      50: 0.98,
      60: 0.94,
      70: 0.88,
      80: 0.8,
      90: 0.6,
    },
  };

  function calculator(opts) {
    var options = {};
    var options_min = {};
    var options_max = {};

    var defaultSettings = {
      // Eingabefelder

      c3: 2, // Haushalt
      c4: 2300, // Verbrauch
      c5: 0, // Ausrichtung
      c6: 30, // Neigung
      c7: 0, // Aufstellfaktor
      c8: 50, // PLZ
      c9: 0, // Ortsfaktor
      c10: 440, // PV-Modul
      c11: 2, // Modulenanzahl
      c11max: 2, // Modulenanzahl Max-Ertrag
      c12: 0, // PV-Peak W
      c13: 0.42, // Strompreis
      c14: 0, // PV-Ertrag_brutto kWh
      c15: 0, // PV-Ersparnis_brutto €
      c16: 0, // Selbstversorgung
      c17: 1, // Akku kWh
      c18: 0, // PV-Kosten
      c19: -800, // Akku-Kosten
      c20: 0, // Gesamtkosten
      energystorage: 0,
      recommendation: 0,
      type_of_roof: "ziegeldach",
    };

    options = $.extend({}, options, defaultSettings);
    options = $.extend({}, options, opts);

    options.c3 = Number(options.c3);
    options.c4 = Number(options.c4);
    options.c5 = Number(options.c5);
    options.c6 = Number(options.c6);
    options.c8 = Number(options.c8);
    options.c13 = Number(options.c13);
    options.recommendation = Number(options.recommendation);

    // Calculation

    console.log(options);

    // Eingabefelder
    if ("c4" in opts == false) options.c4 = verbrauch[options.c3]; // Verbrauch

    // Modification C11 | Jahresverbrauch
    $(".products_calculator.active > * > *").removeClass("active");

    if (options.place_of_installation == "balkon") {
      if (options.c4 >= 1500) {
        options.c11 = 2;
        options.c11max = 2;
        $(".products_calculator.active > * > *:nth-child(2)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(2)").attr(
          "recommendation",
          "0",
        );
        $(".recommendation-form").addClass("hidden");
        $(".chart-legend").addClass("hidden");
      } else {
        options.c11 = 1;
        options.c11max = 2;
        $(".products_calculator.active > * > *:nth-child(1)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(1)").attr(
          "recommendation",
          "0",
        );
        $(".products_calculator.active > * > *:nth-child(2)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(2)").attr(
          "recommendation",
          "1",
        );
        $(".recommendation-form").removeClass("hidden");
        $(".chart-legend").removeClass("hidden");
      }
    } else {
      if (options.c4 >= 3000) {
        options.c11 = 4;
        options.c11max = 4;
        $(".products_calculator.active > * > *:nth-child(4)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(4)").attr(
          "recommendation",
          "0",
        );
        $(".recommendation-form").addClass("hidden");
        $(".chart-legend").addClass("hidden");
      } else if (options.c4 >= 2500) {
        options.c11 = 3;
        options.c11max = 4;
        $(".products_calculator.active > * > *:nth-child(3)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(3)").attr(
          "recommendation",
          "0",
        );
        $(".products_calculator.active > * > *:nth-child(4)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(4)").attr(
          "recommendation",
          "1",
        );
        $(".recommendation-form").removeClass("hidden");
        $(".chart-legend").removeClass("hidden");
      } else if (options.c4 >= 1500) {
        options.c11 = 2;
        options.c11max = 4;
        $(".products_calculator.active > * > *:nth-child(2)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(2)").attr(
          "recommendation",
          "0",
        );
        $(".products_calculator.active > * > *:nth-child(4)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(4)").attr(
          "recommendation",
          "1",
        );
        $(".recommendation-form").removeClass("hidden");
        $(".chart-legend").removeClass("hidden");
      } else {
        options.c11 = 1;
        options.c11max = 2;
        $(".products_calculator.active > * > *:nth-child(1)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(1)").attr(
          "recommendation",
          "0",
        );
        $(".products_calculator.active > * > *:nth-child(2)").addClass(
          "active",
        );
        $(".products_calculator.active > * > *:nth-child(2)").attr(
          "recommendation",
          "1",
        );
        $(".recommendation-form").removeClass("hidden");
        $(".chart-legend").removeClass("hidden");
      }
    }

    function calculation(moduls, old_opts, new_opts) {
      var temp_opts = old_opts;

      temp_opts.c11 = moduls;

      temp_opts.c7 = aufstellfaktor[temp_opts.c5][temp_opts.c6]; // Aufstellfaktor
      temp_opts.c9 = plz[temp_opts.c8]; // Ortsfaktor
      temp_opts.c12 = temp_opts.c10 * temp_opts.c11; // PV-Peak W
      temp_opts.c14 = temp_opts.c7 * temp_opts.c9 * temp_opts.c12; // PV-Ertrag_brutto kWh
      temp_opts.c15 = temp_opts.c13 * temp_opts.c14; // PV-Ersparnis_brutto €
      temp_opts.c16 = (temp_opts.c14 / temp_opts.c4) * 100; // Selbstversorgung
      temp_opts.c18 = temp_opts.c11 * -350; // PV-Kosten
      temp_opts.c20 = temp_opts.c18 + temp_opts.c19; // Gesamtkosten

      // Ergebnisfelder

      // ohne Akku
      temp_opts.g4 =
        Math.pow(0.81, temp_opts.c11 - 1) *
        0.555 *
        (1 + (temp_opts.c3 - 1) / 10) *
        (1 - (temp_opts.c3 - 1) / 100) *
        (2.9 - temp_opts.c3 / 10) *
        Math.pow(temp_opts.c4 / 8000, 0.5); // PV-Nutzung
      temp_opts.g3 = parseInt((temp_opts.g4 * temp_opts.c14).toFixed(0)); // PV-Nutzung_netto kWh
      temp_opts.g5 = temp_opts.g3 * temp_opts.c13; // Ersparnis €
      temp_opts.g5max = temp_opts.c14 * temp_opts.c13; // Ersparnis €
      temp_opts.g6 = temp_opts.g3 / temp_opts.c4; // Selbstversorgung

      // mit Akku
      temp_opts.g7 = temp_opts.g3 + temp_opts.c17 * 213; // PV-Nutzung_netto kWh
      temp_opts.g8 = temp_opts.g7 / temp_opts.c14; // PV-Nutzung
      temp_opts.g9 = temp_opts.g7 * temp_opts.c13; // Ersparnis €
      temp_opts.g10 = temp_opts.g7 / temp_opts.c4; // Selbstversorgung

      // Beispiele

      // ohne Akku
      temp_opts.g13 = (temp_opts.g3 / 70) * 12; // Kühlschrankb. ü Monate
      temp_opts.g14 = temp_opts.g3 / 0.7; // Waschgänge
      temp_opts.g15 = temp_opts.g3 / 0.9 / 8; // Homeoffice Tage

      temp_opts.g13max = (temp_opts.c14 / 70) * 12; // Kühlschrankb. ü Monate
      temp_opts.g14max = temp_opts.c14 / 0.7; // Waschgänge
      temp_opts.g15max = temp_opts.c14 / 0.9 / 8; // Homeoffice Tage

      // mit Akku
      temp_opts.g16 = (temp_opts.g7 / 70) * 12; // Kühlschrankb. ü Monate
      temp_opts.g17 = temp_opts.g7 / 0.7; // Waschgänge
      temp_opts.g18 = temp_opts.g7 / 0.9 / 8; // Homeoffice Tage

      temp_opts.modul_price = modul_price[temp_opts.c11];

      var new_opts = temp_opts;

      return new_opts;
    }

    options_min = calculation(options.c11, options, options_min);
    options_min = $.extend({}, options_min, options);

    // options_min.g3 = Number(options_min.g3);
    // options_min.g5 = Number(options_min.g5);
    // options_min.g6 = Number(options_min.g6);
    // options_min.g7 = Number(options_min.g7);
    // options_min.g9 = Number(options_min.g9);
    // options_min.g10 = Number(options_min.g10);
    // options_min.c15 = Number(options_min.c15);
    // options_min.c14 = Number(options_min.c14);
    // options_min.c16 = Number(options_min.c16);

    options_max = calculation(options.c11max, options, options_max);
    options_max = $.extend({}, options_max, options);

    // Ergebnis

    const ergebnis_ersparnis = document.getElementById("ergebnis_ersparnis");
    if (options.recommendation == 0) {
      if (
        Number(options_min.g5.toFixed(0)) <= Number(options_min.c15.toFixed(0))
      ) {
        ergebnis_ersparnis.innerHTML = options_min.g5.toFixed(0);
      } else {
        ergebnis_ersparnis.innerHTML = options_min.c15.toFixed(0);
      }
    } else {
      if (options_max.g9.toFixed(0) <= options_max.c15.toFixed(0)) {
        ergebnis_ersparnis.innerHTML = options_max.g5.toFixed(0);
      } else {
        ergebnis_ersparnis.innerHTML = options_max.c15.toFixed(0);
      }
    }

    const ergebnis_ertrag = document.getElementById("ergebnis_ertrag");
    if (options.recommendation == 0) {
      if (
        Number(options_min.g3.toFixed(0)) <= Number(options_min.c14.toFixed(0))
      ) {
        ergebnis_ertrag.innerHTML = options_min.c14.toFixed(0);
      } else {
        ergebnis_ertrag.innerHTML = options_min.c14.toFixed(0);
      }
    } else {
      if (options_max.g7.toFixed(0) <= options_max.c14.toFixed(0)) {
        ergebnis_ertrag.innerHTML = options_max.c14.toFixed(0);
      } else {
        ergebnis_ertrag.innerHTML = options_max.c14.toFixed(0);
      }
    }

    const ergebnis_selbstversorgung = document.getElementById(
      "ergebnis_selbstversorgung",
    );
    if (options.recommendation == 0) {
      if ((options_min.g6 * 100).toFixed(2) <= options_min.c16.toFixed(2)) {
        ergebnis_selbstversorgung.innerHTML = (options_min.g6 * 100).toFixed(2);
      } else {
        ergebnis_selbstversorgung.innerHTML = options_min.c16.toFixed(2);
      }
    } else {
      if ((options_max.g10 * 100).toFixed(2) <= options_max.c16.toFixed(2)) {
        ergebnis_selbstversorgung.innerHTML = (options_max.g6 * 100).toFixed(2);
      } else {
        ergebnis_selbstversorgung.innerHTML = options_max.c16.toFixed(2);
      }
    }

    // Ergebnis ideal
    const ergebnis_c15 = document.getElementById("c15");
    if (options.recommendation == 0) {
      ergebnis_c15.innerHTML = options_min.c15.toFixed(0);
    } else {
      ergebnis_c15.innerHTML = options_max.c15.toFixed(0);
    }

    // const ergebnis_c14 = document.getElementById('c14');
    // ergebnis_c14.innerHTML = options.c14.toFixed(0);

    // const ergebnis_c16 = document.getElementById('c16');
    // ergebnis_c16.innerHTML = options.c16.toFixed(2);

    // Ergebnis Beispiele
    const ergebnis_ho = document.getElementById("ergebnis_ho");
    const ergebnis_freezer = document.getElementById("ergebnis_freezer");
    const ergebnis_waschen = document.getElementById("ergebnis_waschen");

    if (options.recommendation == 0) {
      if (options_min.g3 <= options_min.c14) {
        ergebnis_ho.innerHTML = options_min.g15.toFixed(0);
        ergebnis_waschen.innerHTML = options_min.g14.toFixed(0);
        ergebnis_freezer.innerHTML = options_min.g13.toFixed(0);
      } else {
        ergebnis_ho.innerHTML = options_min.g15max.toFixed(0);
        ergebnis_waschen.innerHTML = options_min.g14max.toFixed(0);
        ergebnis_freezer.innerHTML = options_min.g13max.toFixed(0);
      }
    } else {
      if (options_max.g3 <= options_max.c14) {
        ergebnis_ho.innerHTML = options_max.g15.toFixed(0);
        ergebnis_waschen.innerHTML = options_max.g14.toFixed(0);
        ergebnis_freezer.innerHTML = options_max.g13.toFixed(0);
      } else {
        ergebnis_ho.innerHTML = options_max.g15max.toFixed(0);
        ergebnis_waschen.innerHTML = options_max.g14max.toFixed(0);
        ergebnis_freezer.innerHTML = options_max.g13max.toFixed(0);
      }
    }

    // const ergebnis_freezer = document.getElementById('ergebnis_freezer');
    // if(options.recommendation == 0){
    //   ergebnis_freezer.innerHTML = options_min.g13.toFixed(0);
    // }else{
    //   ergebnis_freezer.innerHTML = options_max.g13.toFixed(0);
    // }

    // const ergebnis_waschen = document.getElementById('ergebnis_waschen');
    // if(options.recommendation == 0){
    //   ergebnis_waschen.innerHTML = options_min.g14.toFixed(0);
    // }else{
    //   ergebnis_waschen.innerHTML = options_max.g14.toFixed(0);
    // }

    // Chart

    var kosten_oa = -350;

    var ersparnis_oa = [];
    for (var i = 0; i <= 10; i++) {
      if (options_min.g5 < options_min.g5max) {
        ersparnis_oa.push(options_min.modul_price + options_min.g5 * 2 * i);
      } else {
        ersparnis_oa.push(options_min.modul_price + options_min.g5max * 2 * i);
      }
    }

    var ersparnis_max = [];
    for (var i = 0; i <= 10; i++) {
      if (options_max.g5 < options_max.g5max) {
        ersparnis_max.push(options_max.modul_price + options_max.g5 * 2 * i);
      } else {
        ersparnis_max.push(options_max.modul_price + options_max.g5max * 2 * i);
      }
    }

    // var kosten_ma = -650;
    // var ersparnis_ma = [];
    // for (var i = 0; i <= 10; i++) {
    //   ersparnis_ma.push((kosten_ma*options.c11) + ((options.g9*2) * i));
    // }

    if (options.recommendation == 0) {
      myLineChart.data.datasets[0].backgroundColor = "#49D4C644"; //blau
      myLineChart.data.datasets[0].borderColor = "#49D4C6"; //blau

      myLineChart.data.datasets[1].backgroundColor = "#00000000";
      myLineChart.data.datasets[1].borderColor = "#FFD70088";

      myLineChart.data.datasets[0].data = ersparnis_oa;
      myLineChart.data.datasets[1].data = ersparnis_max;
    } else {
      myLineChart.data.datasets[1].backgroundColor = "#00000000"; //blau
      myLineChart.data.datasets[1].borderColor = "#49D4C688"; //blau

      myLineChart.data.datasets[0].backgroundColor = "#FFD70044";
      myLineChart.data.datasets[0].borderColor = "#FFD700";

      myLineChart.data.datasets[1].data = ersparnis_oa;
      myLineChart.data.datasets[0].data = ersparnis_max;
    }

    myLineChart.update();

    // Update Forms

    if ("c4" in opts == false)
      $('.calculator-section input[name="c4"]').attr("placeholder", options.c4);
  }
  // END -- Calculator

  // Chart

  const ctx = document.getElementById("myChart");

  const myLineChart = new Chart(ctx, {
    type: "line",
    data: {
      labels: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20],
      datasets: [
        {
          label: "Euro",
          borderWidth: 3,
          fill: true,
          backgroundColor: "#49D4C644",
          borderColor: "#49D4C6",
          // borderDash: [5, 5],
          pointStyle: false,
          data: [0],
        },
        {
          label: "Euro",
          fill: true,
          backgroundColor: "#FFD70044",
          borderColor: "#FFD700",
          pointStyle: false,
          borderWidth: 3,
          data: [0],
        },
        {
          label: "Break-even-Point",
          fill: false,
          backgroundColor: "#000000",
          borderColor: "#000000",
          pointStyle: false,
          borderWidth: 1,
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
    },
    options: {
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: "Jahre",
          },
        },
        y: {
          title: {
            display: true,
            text: "Euro",
          },
        },
      },
    },
  });

  // END -- Chart

  // Get URL Parameters

  var get_url = window.location.href;
  if (get_url.includes("?")) {
    get_url = decodeURI(get_url);
    get_url = get_url.split("?");
    get_url = get_url[1];

    if (get_url.includes("c3")) {
      var get_c3 = get_url.split("c3=");
      get_c3 = get_c3[1].split("&");
      $('[name="c3"]').attr("value", get_c3[0]);
    }
    if (get_url.includes("c8")) {
      var get_c8 = get_url.split("c8=");
      get_c8 = get_c8[1].split("&");
      $('[name="c8"]').attr("value", get_c8[0]);
    }
    if (get_url.includes("place_of_installation")) {
      var get_place_of_installation = get_url.split("place_of_installation=");
      get_place_of_installation = get_place_of_installation[1].split("&");
      $('[name="place_of_installation>option"]').attr("selected", false);
      $(
        '[name="place_of_installation"]>option[value="' +
          get_place_of_installation[0] +
          '"]',
      ).attr("selected", true);
      $('[name="c6"]>option').attr("selected", false);
      $(
        '[name="c6"]>option[value="' +
          default_winkel[get_place_of_installation[0]] +
          '"]',
      ).attr("selected", true);
    }
  }

  // END -- Get URL Parameters

  // Change Function

  $(".calculator-section input, .calculator-section select").change(
    function () {
      // Modification of min & max

      if (this.name == "c3") {
        if (this.value < 0 && this.value != "") {
          $('[name="c3"]').prop("value", "0");
        }
        if (this.value > 6 && this.value != "") {
          $('[name="c3"]').prop("value", "6");
        }
      }

      if (this.name == "c4") {
        if (this.value < 1000 && this.value != "") {
          $('[name="c4"]').prop("value", "1000");
        }
      }

      if (this.name == "c13") {
        if (this.value < 0.2 && this.value != "") {
          $('[name="c13"]').prop("value", "0.20");
        }
        if (this.value > 0.8 && this.value != "") {
          $('[name="c13"]').prop("value", "0.80");
        }
      }

      if (this.name == "c8") {
        if (this.value < 10000 && this.value != "") {
          $('[name="c8"]').prop("value", "10000");
        }
        if (this.value > 99999 && this.value != "") {
          $('[name="c8"]').prop("value", "99999");
        }
      }

      // Calculation

      var opts = {};

      if (this.name == "place_of_installation") {
        $('[name="c6"]>option').attr("selected", false);
        $(
          '[name="c6"]>option[value="' + default_winkel[this.value] + '"]',
        ).attr("selected", true);
      }

      if (this.name == "c13") {
        if (this.value == "0.42" || this.value == "0,42") {
          $(this).addClass("placeholder");
        } else {
          $(this).removeClass("placeholder");
        }
      }

      if ($('[name="place_of_installation"]')[0].value != 0) {
        $("[data-productlist]").removeClass("active");
        $(
          '[data-productlist="' +
            $('[name="place_of_installation"]')[0].value +
            '"]',
        ).addClass("active");
      } else {
        $("[data-productlist]").removeClass("active");
      }

      if ($('[name="type_of_roof"]')[0].value != 0) {
        $("[data-productlistinner]").removeClass("active");
        $(
          '[data-productlistinner="' +
            $('[name="type_of_roof"]')[0].value +
            '"]',
        ).addClass("active");
      } else {
        $("[data-productlistinner]").removeClass("active");
      }

      $(".section-calculator .products_calculator > * > *").removeClass(
        "active",
      );
      // $('.section-calculator .products_calculator > * > *:nth-child('+($('[name="c11"]')[0].value-1)+')').addClass('active');

      $(".calculator-section input, .calculator-section select").each(
        function () {
          var name = this.name;
          var value = this.value;

          if (name == "c8") value = value.substring(0, 2);

          if (value != "") {
            if (this.type == "radio" || this.type == "checkbox") {
              if ($(this).is(":checked")) {
                opts[name] = value;
              }
            } else {
              opts[name] = value;
            }
          }
        },
      );

      calculator(opts);

      if ("recommendation" in opts == true) {
        if ($('[name="recommendation"]:checked').length) {
          $(".products_calculator .grid__item").removeClass("selected");
          if ($('[name="recommendation"]:checked')[0].value == "1") {
            $(
              '.products_calculator .grid__item.active[recommendation="1"]',
            ).addClass("selected");
          } else {
            $(
              '.products_calculator .grid__item.active[recommendation="0"]',
            ).addClass("selected");
          }

          $(".products_calculator .grid__item .card__media .badge").remove();
          $(".products_calculator .grid__item .card .button").removeClass(
            "button--secondary",
          );
          $(".products_calculator .grid__item .card .button").addClass(
            "color-scheme-5",
          );
          // $('.products_calculator .grid__item.active[recommendation="0"] .card__media .badge').removeClass('badge--berry');
          // $('.products_calculator .grid__item.active[recommendation="0"] .card__media .badge').addClass('badge--yellow');
          // $('.products_calculator .grid__item.active[recommendation="0"] .card__media .badge').html('Einsteiger');

          // $('.products_calculator .grid__item.active[recommendation="1"] .card__media .badge').removeClass('badge--yellow');
          // $('.products_calculator .grid__item.active[recommendation="1"] .card__media .badge').addClass('badge--berry');
          // $('.products_calculator .grid__item.active[recommendation="1"] .card__media .badge').html('Profi');
        }
      }

      // Form Steps

      // Step 1
      if ("c3" in opts == true && opts.c3 != 0) {
        if (!$(".calc-section.calc-item-1").hasClass("active")) {
          $(".calc-section.calc-item-1").addClass("active");
        }
      } else {
        $(".calc-section.calc-item-1").removeClass("active");
      }

      // Step 2
      if (
        "place_of_installation" in opts == true &&
        opts.place_of_installation != 0
      ) {
        $('[data-bs="place_of_installation"]').removeClass("inactive");

        if (opts.place_of_installation == "schraegdach") {
          $(".type_of_roof_content").addClass("active");
          if ("type_of_roof" in opts == true && opts.type_of_roof != 0) {
            $('[data-bs="type_of_roof"]').removeClass("inactive");
            if (!$(".calc-section.calc-item-2").hasClass("active")) {
              $(".calc-section.calc-item-2").addClass("active");
            }
          } else {
            $(".calc-section.calc-item-2").removeClass("active");
          }
        } else {
          $(".type_of_roof_content").removeClass("active");
          if (!$(".calc-section.calc-item-2").hasClass("active")) {
            $(".calc-section.calc-item-2").addClass("active");
          }
        }
      } else {
        $(".calc-section.calc-item-2").removeClass("active");
      }
    },
  );

  $('.calculator-section input[name="c3"]').trigger("change");

  $('[name="c3"]').on("keyup", function () {
    var keydown_input = Number($('[name="c3"]')[0].value);
    if (this.name == "c3") {
      var temp_new_value = "1";
      var temp_value_c3 = this.value.split("");
      for (var i = 0; i < temp_value_c3.length; i++) {
        if (Number(temp_value_c3[i]) === 0)
          temp_new_value += temp_value_c3[i]; // is 0
        else if (Number(temp_value_c3[i])) temp_new_value += temp_value_c3[i];
      }
      $(this).prop("value", temp_new_value);
    }
    if (keydown_input >= 1) {
      $('[name="c3"]').trigger("change");
    }
  });

  // var temp_value_c4 = 1000;
  $('[name="c4"]').on("keyup", function () {
    var keydown_input = Number($('[name="c4"]')[0].value);
    if (this.name == "c4") {
      var temp_new_value = "";
      var temp_value_c4 = this.value.split("");
      for (var i = 0; i < temp_value_c4.length; i++) {
        if (Number(temp_value_c4[i]) === 0)
          temp_new_value += temp_value_c4[i]; // is 0
        else if (Number(temp_value_c4[i])) temp_new_value += temp_value_c4[i];
      }
      $(this).prop("value", temp_new_value);
    }
    if (keydown_input >= 1000) {
      if (keydown_input > 8500) {
        $('[name="c4"]').prop("value", "8500");
      }
      $('[name="c4"]').trigger("change");
    }
  });

  $('[name="c13"]').on("keyup", function () {
    var keydown_input = Number($('[name="c13"]')[0].value);

    if ($('[name="c13"]')[0].value.length >= 4) {
      if (this.name == "c13") {
        if (this.value == "") {
          // empty || Buchstabe
          $(this).prop("value", "");
        } else if (this.value > 0) {
          // Zahl
          $(this).prop("value", keydown_input.toFixed(2));
        } else {
          // 0
          $(this).prop("value", keydown_input.toFixed(2));
        }
      }

      $('[name="c13"]').trigger("change");
    } else if ($('[name="c13"]')[0].value.length == 0) {
      if (this.value == "") {
        // empty || Buchstabe
        $(this).prop("value", "");
      } else if (this.value > 0) {
        // Zahl
        $(this).prop("value", keydown_input.toFixed(2));
      } else {
        // 0
        $(this).prop("value", keydown_input.toFixed(2));
      }
    }
  });

  $('[name="c8"]').on("keyup", function () {
    var keydown_input = Number($('[name="c8"]')[0].value);
    if (this.name == "c8") {
      var temp_new_value = "";
      var temp_value_c8 = this.value.split("");
      for (var i = 0; i < temp_value_c8.length; i++) {
        if (Number(temp_value_c8[i]) === 0)
          temp_new_value += temp_value_c8[i]; // is 0
        else if (Number(temp_value_c8[i])) temp_new_value += temp_value_c8[i];
      }
      $(this).prop("value", temp_new_value);
    }
    if (keydown_input >= 10000) {
      $('[name="c8"]').trigger("change");
    }
  });

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >=
      $("#products-scroll-target").offset().top - $(window).height() / 2
    ) {
      $(".produktempfehlung-btn").addClass("unvisible");
    } else {
      $(".produktempfehlung-btn").removeClass("unvisible");
    }
  });
})(jQuery);
